/**
 * `onOpenAutoFocus` for a dialog whose first focusable control can be an unavailable `ReasonButton` (UI review F6):
 * Radix would focus it on open, and a focus that no pointer caused opens its reason tooltip by itself. This focuses the
 * first focusable control that is NOT `aria-disabled` instead (an input, Retry, Cancel), and keeps Radix's default when
 * the content holds none.
 */
const FOCUSABLE = 'input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [href], [tabindex]:not([tabindex="-1"])';

export function focusFirstAvailableControl(event: Event): void {
  const root = event.target instanceof HTMLElement ? event.target : null;
  const first = root ? [...root.querySelectorAll<HTMLElement>(FOCUSABLE)].find((element) => element.getAttribute('aria-disabled') !== 'true') : undefined;
  if (!first) return;
  event.preventDefault();
  first.focus();
}
